import React from 'react';

function AboutUs() {
  return (
    <div className="container" style={{ padding: '64px 0 96px', maxWidth: 760 }}>
      <span className="section-label">About Us</span>
      <h1 style={{ marginBottom: 20 }}>Quality products, honest prices</h1>
      <p style={{ marginBottom: 16 }}>
        We started this store to make everyday shopping simple: a curated
        catalog, fair pricing, and fast delivery, without the noise.
      </p>
      <p>
        Every product listed is picked for quality and value. If something
        isn't right, our support team is one message away.
      </p>
    </div>
  );
}

export default AboutUs;
